import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { HISTORICAL_URL } from 'app/@common/constants'


export default function SelectProvince({...props}) {

    const myProps = {
        urlAjax: HISTORICAL_URL.PROVINCE,
        placeholder: i18n.t('common:filters.province'),
        icon: { icon: 'map-marker' },
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}